import { getProduct } from "services/stripeService";
import { launchStripeCheckout } from "utils/stripeCheckout";

const handleSubscribe = async (storeId: string): Promise<void> => {
    try {
        const response = await getProduct();
        const recurringPriceId = response?.data?.products?.[0]?.price_id;

        if (!recurringPriceId) {
            console.error("Unable to find a Stripe subscription price for checkout");
            return;
        }

        const checkoutResult = await launchStripeCheckout({
            recurring_price_id: recurringPriceId,
            scanner_price_id: null,
            store_id: storeId,
            require_cc_for_trial: false
        });

        if (!checkoutResult.success) {
            console.error("Error creating checkout session:", checkoutResult.error);
            return;
        }
    } catch (error) {
        console.error("Error subscribing to store:", error);
    }
};

export default handleSubscribe; 
